module.exports = __webpack_public_path__ + "static/media/bl.994df095.svg";